export default "__VITE_ASSET__BXMzYn$e__"